import { api } from "../../services";

const customfield = {

state: {
  loadingChannels: new Set(),
  customfields: [],
  customfield: {},
  search_customfields: {},
  customfieldForm: {
    field_name: "",
    field_type: "string", 
    hidden: false,
    field_name_slug: "",
  }
},
  getters: {
    getCustomFields: state => state.customfields,
    getCustomField: state => state.customfield,
  },
  mutations: {
    
    SET_CUSTOM_FIELD_FORM(state, form) {
      state.customfieldForm = { ...form };
    },
  
    RESET_CUSTOM_FIELD_FORM(state) {
      state.customfieldForm = {
        field_name: "",
        field_type: "string",
        hidden: false,
        field_name_slug: "",
      };
    },
    SET_CUSTOM_FIELDS(state, fields) {
      state.customfields = fields;
    },
    ADD_CUSTOM_FIELD(state, field) {
      state.customfields.push(field);
    },
    UPDATE_CUSTOM_FIELD(state, updatedField) {
      const index = state.customfields.findIndex(f => f.id === updatedField.id);
      if (index !== -1) {
        state.customfields.splice(index, 1, updatedField);
      }
    },
    DELETE_CUSTOM_FIELD(state, fieldId) {
      state.customfields = state.customfields.filter(f => f.id !== fieldId);
    }
  },
  actions: {
       async fetchCustomFields({ commit, state }, channelId) {
      // Prevent duplicate requests for the same channel
      if (state.loadingChannels.has(channelId)) {
        return state.customfields;
      }

      try {
        state.loadingChannels.add(channelId);
        const res = await api.get(`channels/${channelId}/custom-fields`);
        const fields = res.data.fields || res.data || [];
        commit('SET_CUSTOM_FIELDS', fields);
        return fields;
      } catch (error) {
        console.error("Erro ao buscar custom fields:", error);
        throw error;
      } finally {
        state.loadingChannels.delete(channelId);
      }
    },
async createCustomField({ commit }, { channelId, field }) {
  try {
    const payload = { fields: [field] };
    const res = await api.post(`channels/${channelId}/custom-fields`, payload);
    const createdField = res.data.fields?.[0] || res.data;
    commit('ADD_CUSTOM_FIELD', createdField);
    return createdField;
  } catch (error) {
    console.error("Erro ao criar campo:", error);
    throw error;
  }
},

    async updateCustomField({ commit }, { channelId, fieldId, field }) {
      try {
        const res = await api.put(`channels/${channelId}/custom-fields/${fieldId}`, field);
        commit('UPDATE_CUSTOM_FIELD', res.data);
        return res.data;
      } catch (error) {
        console.error("Erro ao atualizar campo:", error);
        throw error;
      }
    },

    async deleteCustomField({ commit }, { channelId, fieldId }) {
      try {
        await api.delete(`channels/${channelId}/custom-fields/${fieldId}`);
        commit('DELETE_CUSTOM_FIELD', fieldId);
      } catch (error) {
        console.error("Erro ao deletar campo:", error);
        throw error;
      }
    },



    // VALORES

    async fetchLeadCustomFieldValues(_, leadId) {
      try {
        const res = await api.get(`leads/${leadId}/custom-fields-values`);
        return res.data.fields || res.data || [];
      } catch (error) {
        console.error("Erro ao buscar valores de campos personalizados do lead:", error);
        throw error;
      }
    },

    async updateLeadCustomFieldValues(_, { leadId, fields }) {
      try {
        const payload = { fields };
        const res = await api.post(`leads/${leadId}/custom-fields-values`, payload);
        return res.data;
      } catch (error) {
        console.error("Erro ao atualizar valores de campos personalizados do lead:", error);
        throw error;
      }
    },
    async deleteLeadCustomFieldValue(_, { leadId, valueId }) {
      try {
        const res = await api.delete(`leads/${leadId}/custom-fields-values/${valueId}`);
        return res.data;
      } catch (error) {
        console.error("Erro ao deletar valor de campo personalizado do lead:", error);
        throw error;
      }
    }
    

  }
};

export default customfield;
